module.exports = __webpack_public_path__ + "static/media/square.and.pencil.bold.fdef3589.svg";